import { usePaymentTemplate } from '@p2p/entities/templates';
import { PAYMENT_STEPS_IDS } from '@p2p/pages/Payment/Payment.constants';
import { usePostDisputeMutation } from '@p2p/services';
import { getFirstErrorMessage } from '@p2p/shared/functions';
import { useParams } from 'react-router-dom';

import { TransferIssues } from './TransferIssues';
import { generateComment } from './TransferIssues.helpers';
import { FormHelper, FormValues } from './TransferIssues.types';

type MainPageDisputeProps = {
  comeback: () => void;
};

export const MainPageDispute = ({ comeback }: MainPageDisputeProps) => {
  const { setStepId } = usePaymentTemplate();
  const [createDispute, { isLoading: isCreatingDispute }] = usePostDisputeMutation();
  const { id = '' } = useParams<{ id: string }>();

  const onSubmit = (data: FormValues, formHelper: FormHelper) => {
    const { selectedIssue, comment, files } = data;
    const { setValue, setError } = formHelper;
    const formData = new FormData();

    formData.append('order_withdrawal_id', id);
    formData.append('user_type', 'user');
    formData.append('comment', generateComment(selectedIssue, comment));
    files.map((file) => formData.append('files', file));

    createDispute(formData)
      .unwrap()
      .then(() => {
        setStepId(PAYMENT_STEPS_IDS.IN_DISPUTE);
      })
      .catch((e) => {
        const errorMessage = e?.data?.order_withdrawal_id?.[0] || e?.data?.[0];
        const _files = e?.data?.files;
        if (_files) {
          const indexesRemoves = Object.keys(_files).map((i) => +i);
          setValue(
            'files',
            files.filter((_, index) => !indexesRemoves.includes(index)),
          );
          const message = Object.values(_files)?.[0] as string;
          if (message) {
            setError('files', { message });
            return;
          }
        }

        const firstErrorMessage = getFirstErrorMessage(e.data);

        if (errorMessage || firstErrorMessage) {
          setError('files', { message: errorMessage || firstErrorMessage });
        }
      });
  };

  return (
    <TransferIssues id={id} comeback={comeback} onSubmit={onSubmit} isLoading={isCreatingDispute} />
  );
};
